import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getAllData = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {
   
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', params, { mode: 'cors' })
   
    return response.data
  })

  export const getBookingdetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingDetails', params, {mode:'cors'})
    return response.data
  })
  export const getDriverLastLocation = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverLocation', params, {mode:'cors'})
    return response.data
  })
  
export const PassengerScreenSlice = createSlice({
    name: 'PassengerScreen',
    initialState: {
      data: [],
      NotificationData: [],
      historydata: [],
      total: 1,
      params: {},
      allData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder

      .addCase(getAllData.fulfilled, (state, action) => {
        state.data = action.payload
      })
           
      // .addCase(GetBookingEditNotif.fulfilled, (state, action) => {
      //   state.BookEdit = action.payload.list
      //   state.lastrec = action.payload.lastrecord.bookingID
      // })

      // .addCase(setBookingEd.fulfilled, (state) => {
      //   state.EditPrevLen = state.BookEdit.length
      // })
    }
})

export default PassengerScreenSlice.reducer